import BoldLabel from './BoldLabel';

export default BoldLabel;
